var map = {
	"./routineA_1.png": 6234,
	"./routineA_2.png": 2067,
	"./routineA_3.png": 4474,
	"./routineA_4.png": 5505,
	"./routineA_5.png": 2389,
	"./routineA_6.png": 9357,
	"./routineB_1.png": 2943,
	"./routineB_2.png": 247,
	"./routineB_3.png": 1067,
	"./routineB_4.png": 9654,
	"./routineB_5.png": 1131,
	"./serum-CAFFEINE.png": 7088,
	"./serum-GLYCOLIC-ACID.png": 3022,
	"./serum-HYALURONIC-ACID.png": 5632,
	"./serum-MP--ALLANTOIN.png": 7678,
	"./serum-MP--ALPHA-ARBUTIN.png": 8769,
	"./serum-MP--ALPHA-LIPOIC-ACID.png": 7153,
	"./serum-MP--ASTAXANTHIN.png": 3077,
	"./serum-MP--AZEALIC-ACID.png": 412,
	"./serum-MP--BAKUCHIOL.png": 6792,
	"./serum-MP--CAFFEINE.png": 2060,
	"./serum-MP--CERAMIDE.png": 6070,
	"./serum-MP--CINNAMONIUM.png": 599,
	"./serum-MP--COQ10.png": 794,
	"./serum-MP--CURCUMIN.png": 2043,
	"./serum-MP--EGCG.png": 8214,
	"./serum-MP--FERULIC-ACID.png": 2540,
	"./serum-MP--GARCINIA-CAMBOGIA.png": 1267,
	"./serum-MP--GLUTATHIONE.png": 6775,
	"./serum-MP--GLYCOLIC-ACID.png": 8054,
	"./serum-MP--HYALURONIC-ACID.png": 748,
	"./serum-MP--MELATONIN.png": 2847,
	"./serum-MP--NIACINAMIDE.png": 5803,
	"./serum-MP--PANTHENOL.png": 3575,
	"./serum-MP--RESVERATROL.png": 8625,
	"./serum-MP--SALICYLIC-ACID.png": 4355,
	"./serum-MP--SHEA-BUTTER.png": 4598,
	"./serum-MP--SQUALENE.png": 2893,
	"./serum-MP--TRANEXAMIC-ACID.png": 8156,
	"./serum-MP--VITAMIN-A.png": 9930,
	"./serum-MP--VITAMIN-C.png": 6945,
	"./serum-MP--VITAMINE-E.png": 1767,
	"./serum-MP--ZINC.png": 8730,
	"./serum-NIACINAMIDE.png": 5403,
	"./serum-VITAMINE-C.png": 5536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1884;